function initAccordions() {
  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-accordion-header')) {

      const allAccordionHeaders = document.querySelectorAll('.js-accordion-header');

      allAccordionHeaders.forEach(header => {
        const accordionContent = header.nextElementSibling;
    
        if (header !== e.target.closest('.js-accordion-header')) {
          header.setAttribute('aria-expanded', 'false');
          accordionContent.style.maxHeight = '0';
          accordionContent.classList.remove('expanded');
        }
      });

      const accordionContent = e.target.nextElementSibling;
      const isExpanded = e.target.getAttribute('aria-expanded') === 'true';

      e.target.setAttribute('aria-expanded', !isExpanded);
      
      if (!isExpanded) {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
      }
      else {
        accordionContent.style.maxHeight = '0';
      }
      
      accordionContent.classList.toggle('expanded');
    }
  })
}

export {
  initAccordions,
}